module.exports = __webpack_public_path__ + "img/pr-8.86555c39.png";